/* * @Author: 刘枫 * @Date: 2020-10-28 10:01:18 * @Last Modified by: 李志远 *
@Last Modified time: 2021-10-Tu 10:06:20 */

<template>
  <section class="public-top-layout">
    <div class="topbar">
      <div
        class="user-entry"
        style="font-size: 16px;"
      >
        您好，欢迎来到
        <router-link
          :to="home"
          style="color: #ec671a"
          title="开心云商"
        >开心云商</router-link>
        <!-- <span v-if="isLogin" class="link" @click="exitSys"> [退出] </span>
        <span class="signBtn" v-if="isLogin && signed != 1" @click="signClick">
          签到
        </span>
        <span
          class="signBtn signed"
          v-if="isLogin && signed == 1"
          @mouseover="showCalendar"
          @mouseout="timeShow = false"
        >
          已签
        </span>
        <span
          class="signBtn pfj businessManage"
          v-if="storeShow"
          @click="toStore"
          @mouseenter="freeShopShow = true"
          @mouseleave="freeShopShow = false"
        >
          商家中心
        </span>
        <span
          class="signBtn pfj"
          v-if="!storeShow && isLogin"
          @click="openShop"
        >
          免费开店
        </span>
        <span class="signBtn pfj" v-if="marketShow" @click="toPfList">
          批发价商品
        </span>
        <span
          class="signBtn pfj"
          v-if="isLogin && firstBuyShow"
          @click="toStore"
        >
          云优品服务站
        </span>
        <span
          class="signBtn pfj"
          v-if="isLogin && firstBuyShow"
          @click="toFirstBuy"
        >
          云优品店长采购平台
        </span>
        <span
          class="signBtn pfj"
          v-if="isLogin && !firstBuyShow"
          @click="openShop"
        >
          申请服务站
        </span>
        <calendar v-show="timeShow" :signDays="signDays"></calendar>
        &nbsp;&nbsp;
        <span v-if="!isLogin">
          <router-link class="banner-text" to="/login" title="会员登录"
            >请登录</router-link
          >
        </span>
        &nbsp;&nbsp;
        <span v-if="!isLogin">
          <router-link class="banner-text" to="/register" title="会员注册"
            >会员注册</router-link
          >
        </span> -->
      </div>
      <div class="quick-menu">
        <dl
          v-if="!name"
          style="width: 100px"
        >
          <dt>
            <p class="menu-top">
              <router-link :to="{ path: '/register' }">注册</router-link><span style="margin: 0 4px">/</span><router-link :to="{ path: '/login' }">登录</router-link>
            </p>
          </dt>
        </dl>
        <dl
          v-else
          style="width: 160px"
          class="userMenuSty"
        >
          <dt style="display: flex; width: 100%;justify-content: center;">
            <div class="avatar">
              <img
                :src="$store.getters.face"
                height="120"
                width="120"
              >
            </div>
            <router-link class="menu-top" :to="{ path: '/member/member' }">{{name}}</router-link>
            <!-- <p class="menu-top">{{ name }}</p> -->
            <i class="el-icon-arrow-down"></i>
          </dt>
          <dd class="userMenuStyChild" style="left: 40px;">
            <ul>
              <li
                v-for="child in loginMenuList"
                :key="name + child.name"
              >
                <router-link
                  :to="child.route"
                  v-if="child.name !== '退出登录'"
                >{{ child.name }}</router-link>
                <a
                  v-else
                  @click="exitSys"
                >{{ child.name }}</a>
              </li>
            </ul>
          </dd>
        </dl>
        <dl style="width: 22px">
          <dt>|</dt>
        </dl>
        <dl
          v-for="(menu, index) in menuList"
          :key="index"
          :style="index == 1 ? 'width:22px' : ''"
        >
          <dt
            @mouseenter="showChild(index)"
            @mouseleave="hideChild"
          >
            <router-link
              :to="menu.route"
              v-if="menu.route"
            >{{
              menu.name
            }}</router-link>
            <p
              v-else
              class="menu-top"
            >{{ menu.name }}</p>
          </dt>

          <dd
            v-if="menu.children"
            v-show="index === hover"
            @mouseenter="showChild(index)"
            @mouseleave="hideChild"
          >
            <ul>
              <li
                v-for="child in menu.children"
                :key="index + child.name"
              >
                <router-link :to="child.route">{{ child.name }}</router-link>
              </li>
            </ul>
          </dd>
          <dd
            v-if="index == 2"
            @mouseenter="showChild(index)"
            @mouseleave="hideChild"
          >
            <div
              class="margin-top"
              v-show="showQr"
            >
              <img
                data-v-4c94b89f=""
                src="../../../assets/images/guy-img.png"
                width="80px"
                height="80px"
              />
            </div>
          </dd>
        </dl>
        <dl style="width: 22px">
          <dt>|</dt>
        </dl>
        <dl class="userMenuSty">
          <dt>
            <p class="menu-top">商家中心</p>
          </dt>
          <dd class="userMenuStyChild">
            <ul style="width: 160px">
              <li>
                <a
                  v-if="storeShow"
                  @click="toStore"
                >商家中心</a>
              </li>
              <li>
                <a
                  v-if="!storeShow && isLogin"
                  @click="openShop"
                >免费开店</a>
              </li>
              <li>
                <a
                  v-if="marketShow"
                  @click="toPfList"
                >批发价商品</a>
              </li>
              <li>
                <a
                  v-if="isLogin && firstBuyShow"
                  @click="toStore"
                >云优品服务站</a>
              </li>
              <li>
                <a
                  v-if="isLogin && firstBuyShow"
                  @click="toFirstBuy"
                >
                  云优品店长采购平台
                </a>
              </li>
              <li>
                <a
                  v-if="isLogin && !firstBuyShow"
                  @click="openShop"
                >
                  申请服务站
                </a>
              </li>
              <li>
                <router-link :to="{ path: '/createLeague' }">联盟商家</router-link>
              </li>
            </ul>
          </dd>
        </dl>
      </div>
    </div>
  </section>
</template>
<script>
import { getSession, setSession } from "utils/tool";
import { memberSign, getSigned, loginOut } from "api/user";
import {
  MOBILE_REG,
  sellerDevelopURL,
  sellerProductURL,
  sellerPrepareURL,
} from "utils/url";
import { track } from "api/goods";
import calendar from "./calendar.vue";
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  components: {
    calendar,
  },
  data() {
    return {
      showQr: false,
      hover: "",
      showUserMenu: false,
      timeShow: false,
      freeShopShow: false,
      signDays: "", // 本月签到日期数的连接字符串
      home: "/index", // 首页路由
      regUrl: MOBILE_REG,
      timmer: null,
      sellerUrl: "",
      isFirstBuyShow: "",
      loginMenuList: [
        {
          name: "我的订单",
          route: { path: "/member/order?status=1" },
        },
        {
          name: "退款/售后",
          route: { path: "/member/returnList" },
        },
        {
          name: "我的资产",
          route: { path: "/account-center" },
        },
        {
          name: "我的收益",
          route: { path: "/member/shoppingScore" },
        },
        {
          name: "我的收藏",
          route: { path: "/member/favorite?status=1" },
        },
        {
          name: "地址管理",
          route: { path: "/member/address" },
        },
        {
          name: "退出登录",
        },
      ],
      menuList: [
        {
          name: "帮助中心",
          route: { path: "/help" },
        },
        {
          name: "|",
        },
        {
          name: "下载app",
        },
        // {
        //   name: "商家中心",
        // },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "sid",
      "name",
      "signed",
      "market",
      "storeId",
      "lucky",
      "isFirstBuy",
    ]),
    isLogin() {
      return this.sid && this.sid.length > 0 ? true : false;
    },
    marketShow: {
      get() {
        return eval(this.market) && this.isLogin;
      },
    },
    storeShow: {
      get() {
        return eval(this.storeId) && this.isLogin;
      },
    },
    firstBuyShow: {
      get() {
        return this.isFirstBuy == 1 && this.isLogin;
      },
    },
  },
  created() {
    console.log(this.name, this.sid, sessionStorage.getItem("sid"));
    if (location.hostname === "www.kxymall.com") {
      this.sellerUrl = sellerProductURL;
    } else if (location.hostname === "prepare.kxymall.com") {
      this.sellerUrl = sellerPrepareURL;
    } else {
      this.sellerUrl = sellerDevelopURL;
    }
  },
  methods: {
    // 显示日历
    showCalendar() {
      this.timeShow = true;
      getSigned().then((resp) => {
        if (resp.resCode === 1) {
          this.signDays = resp.data.signDate;
        }
      });
    },
    // 显示菜单
    showChild(index) {
      clearTimeout(this.timeout);
      this.hover = index;
      this.showUserMenu = false;
      if (index == 2) {
        this.showQr = true;
      } else {
        this.showQr = false;
      }
    },
    // 隐藏菜单
    hideChild() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.hover = "";
        this.showQr = false;
      }, 200);
    },
    // 退出系统
    exitSys() {
      let data = {
        userBehaviorsLogDTOList: [
          {
            operationObject: 3,
            operationPage: this.$route.path,
            operationStatus: 1,
            operationType: 6,
            username: localStorage.getItem("userName"),
            operationLocation: 1,
            operationApi: "",
            deviceType: 1,
            deviceSystem: 1,
            failureReason: "",
            browser: window.navigator.appCodeName,
            deviceVersion: window.navigator.platform,
            startTime: moment().format("YYYY-MM-DD HH:mm:ss"),
            endTime: moment().format("YYYY-MM-DD HH:mm:ss"),
          },
        ],
      };
      track(data).then((res) => {});
      this.$store
        .dispatch("LogOut", {})
        .then(() => {
          this.$store.dispatch("cleanCartLogOut");
          this.timeShow = false;
          localStorage.clear()
          sessionStorage.clear()
          // this.isLogin = false;
          this.$Modal.success({
            content: "退出系统成功!",
            onOk: () => {
              if (this.$route.path === "/index") {
                window.history.go(0);
              } else {
                let self = this;
                setTimeout(() => {
                  self.$router.push({
                    path: "/index",
                  });
                }, 500);
              }
              window.location.reload();
            },
          });
        })
        .catch((err) => {
          this.$Loading.error();
          this.$Message.error(err);
        });
    },
    // 签到
    signClick() {
      memberSign()
        .then((resp) => {
          if (resp.resCode === 1) {
            let message = "恭喜您，签到成功！";
            let width = 300; //屏蔽签到送抽奖
            /*if (resp.data.luck === 1) {
            this.$store.dispatch('getLucky');
            width=500;
            message="恭喜您，本月连续签到10次，获得一次抽奖机会！";
          }*/ this.$Modal.success({
              width: width,
              content: message,
            });

            this.$store.dispatch("getSigned");
          } else {
            this.$Modal.error({
              width: 300,
              content: resp.resDesc,
            });
          }
        })
        .catch(() => {
          this.$Modal.error({
            width: 300,
            content: "Sorry，签到失败！",
          });
        });
    },
    // 批发商品列表
    toPfList() {
      this.$router.push({
        path: "/goods-list?goodsType=batch",
      });
    },
    // 云优品店长采购平台
    toFirstBuy() {
      this.$router.push({
        path: "/first-buy-list",
      });
    },
    // 跳转商家管理中心
    toStore() {
      let sid = getSession("sid");
      let token = getSession("token");
      let targetUrl =
        this.sellerUrl +
        "/templates/index.html?loginSource=buyer&sid=" +
        sid +
        "&token=" +
        token;
      window.open(targetUrl);
    },
    // 跳转到免费开店和申请云优品店
    openShop() {
      let sid = getSession("sid");
      let token = getSession("token");
      let targetUrl =
        this.sellerUrl +
        "/templates/index.html?loginSource=buyer&sid=" +
        sid +
        "&token=" +
        token;
      window.open(targetUrl);
    },
    // 申请联盟商家
    applyBusiness() {
      let sid = getSession("sid");
      let token = getSession("token");
      let targetUrl =
        this.sellerUrl +
        "/templates/league/create_league.html?loginSource=buyer&sid=" +
        sid +
        "&token=" +
        token;
      window.open(targetUrl);
    },
    // 申请实体店
    openStore() {
      let sid = getSession("sid");
      let token = getSession("token");
      let targetUrl =
        this.sellerUrl +
        "/templates/reportCenter/apply.html?loginSource=buyer&sid=" +
        sid +
        "&token=" +
        token;
      window.open(targetUrl);
    },
  },
};
</script>
<style lang="less" scoped>
.banner-text {
  color: #fff;
  &:hover {
    color: #ec671a;
  }
}
.menu-top {
  cursor: pointer;
  &:hover {
    color: #ec671a;
  }
}
.margin-top {
  margin: 40px 0 0 2px;
}
.userMenuStyChild {
  display: none;
}
.userMenuSty:hover .userMenuStyChild {
  display: block;
}
.avatar {
  margin-right: 8px;
}
.avatar img {
  width: 28px;
  height: 28px;
  border-radius: 14px;
}
</style>



// WEBPACK FOOTER //
// top-layout.vue?6ae2e26c